export default __webpack_public_path__ + "static/Birchbrook_Icon_Lavender-f94d9c250baca5787c933e0830c23adb.svg";